var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeProperty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 319,
    viewBox: "0 0 472 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_554_13413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.641 185.436C411.482 185.336 411.322 185.246 411.152 185.146C399.663 178.452 386.117 175.874 373.071 172.647C360.943 169.65 347.327 165.623 338.014 156.781C326.695 146.03 328.272 131.214 332.624 117.755C337.196 103.628 341.508 89.3905 339.482 74.3938C337.176 57.2989 329.49 40.7935 317.272 27.9649C298.316 8.0625 268.939 -2.48816 240.8 0.499197C203.038 4.50565 172.024 30.5626 148.476 58.7976C133.024 77.3212 123.911 98.3526 106.282 115.947C88.8639 133.332 69.2892 148.998 54.6357 168.7C35.1209 194.917 25.618 228.358 31.9466 259.87C38.2852 291.382 61.4234 320.136 93.1162 331.516C113.3 338.76 135.44 338.91 157.021 338.97C201.86 339.09 246.749 339.199 291.438 335.802C320.845 333.564 350.651 329.658 377.443 317.968C404.235 306.279 427.962 285.747 436.746 259.09C445.47 232.604 436.397 200.222 411.631 185.446L411.641 185.436Z",
    fill: "#BFD2FF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_554_13413)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 116,
    width: 345,
    height: 61,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 145.5,
    r: 20.5,
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 135,
    width: 21,
    height: 7,
    rx: 3,
    fill: "#84BBFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 135,
    width: 57,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 149,
    width: 115,
    height: 7,
    rx: 3,
    fill: "#D7E2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 130,
    width: 79,
    height: 31,
    fill: "#DDEDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.927 134.617H71.896V312H396.927V134.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.93 293.483H71.668V311.792H396.93V293.483Z",
    fill: "#83BAFA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.777 27H154.786V90.938H183.777V27Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.031 135.387H54L73.4382 102.647H395.619L415.031 135.387Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.499 71.8604H120.351V312H348.499V71.8604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.913 104.574H100.914L120.352 71.8604H348.474L367.913 104.574Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.886 199.147V137.751H154.787V199.147H187.886Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.777 141.858H158.896V190.903H183.777V141.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19 162.274H156.301V164.662H186.19V162.274Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.088 140.088H165.829V164.148H168.088V140.088Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.616 140.088H175.356V164.148H177.616V140.088Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.711 199.225H150.986V206.671H191.711V199.225Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M191.711 203.535H150.986V206.848H191.711V203.535Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.907 199.147V137.751H277.808V199.147H310.907Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.8 141.858H281.918V190.903H306.8V141.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.211 162.274H279.322V164.662H309.211V162.274Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.11 140.088H288.85V164.148H291.11V140.088Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.638 140.088H298.378V164.148H300.638V140.088Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.734 199.224H274.009V206.67H314.734V199.224Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M314.734 203.535H274.009V206.848H314.734V203.535Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.351 126.451H147.467V137.724H316.351V126.451Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.024 199.426V153C215.024 143.037 223.138 134.923 233.101 134.923C243.064 134.923 251.178 143.037 251.178 153V199.426H215.05H215.024Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.379 195.653H218.774V153.002C218.774 145.093 225.168 138.699 233.077 138.699C240.985 138.699 247.379 145.093 247.379 153.002V195.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.843 159.341V156.491H216.333V159.341H249.843Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.797 136.696H232.024V158.163H234.797V136.696Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.208 199.22H212.482V206.666H253.208V199.22Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M253.208 203.534H212.482V206.847H253.208V203.534Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.953 147.454H247.406C247.406 147.454 245.583 137.183 234.798 136.721C224.013 136.259 217.953 147.454 217.953 147.454Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M348.499 293.69H120.351V311.999H348.499V293.69Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.55 229.163H206.655V312H258.55V229.163Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.21 234.939H212.485V311.999H253.21V234.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.454 302.857H201.235V311.999H264.454V302.857Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.082 293.69H212.511V302.832H253.082V293.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.845 239.895H216.335V251.09H249.845V239.895Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.845 254.3H216.335V290.249H249.845V254.3Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.042 267.704C245.899 267.704 247.405 266.198 247.405 264.34C247.405 262.483 245.899 260.977 244.042 260.977C242.184 260.977 240.678 262.483 240.678 264.34C240.678 266.198 242.184 267.704 244.042 267.704Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.359 234.656V193.083H85.9426V234.656H108.359Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.586 195.854H88.7417V229.056H105.586V195.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.206 209.697H86.9722V211.315H107.206V209.697Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9562 194.676H93.4155V210.956H94.9562V194.676Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.401 194.676H99.8604V210.956H101.401V194.676Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.929 234.731H83.3506V239.79H110.929V234.731Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M110.929 237.635H83.3506V239.869H110.929V237.635Z",
    fill: "#9FAFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.242 234.656V193.083H361.825V234.656H384.242Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.444 195.854H364.599V229.056H381.444V195.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06 209.697H362.826V211.315H383.06V209.697Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.814 194.676H369.273V210.956H370.814V194.676Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.283 194.676H375.743V210.956H377.283V194.676Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.809 234.731H359.231V239.79H386.809V234.731Z",
    fill: "#E6EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M386.809 237.635H359.231V239.869H386.809V237.635Z",
    fill: "#9FAFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.808,
    y: 187.968,
    width: 126.244,
    height: 126.244,
    rx: 63.1221,
    fill: "#DDEDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.808,
    y: 187.968,
    width: 126.244,
    height: 126.244,
    rx: 63.1221,
    stroke: "#86BCFA",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.15 294.407C396.437 294.407 395.758 294.103 395.281 293.57L387.701 285.109C387.283 284.643 387.052 284.037 387.052 283.409V251.445C383.552 249.707 380.557 247.1 378.323 243.829C375.696 239.984 374.308 235.476 374.308 230.792C374.308 218.098 384.555 207.771 397.15 207.771C409.745 207.771 419.992 218.098 419.992 230.792C419.992 235.476 418.603 239.984 415.977 243.829C413.742 247.1 410.748 249.707 407.247 251.445V255.771C407.247 256.303 407.082 256.822 406.773 257.254L404.628 260.257L406.759 263.18C407.076 263.615 407.247 264.142 407.247 264.683V269.721C407.247 270.323 407.035 270.905 406.648 271.364L404.576 273.822L406.761 276.829C407.077 277.264 407.247 277.789 407.247 278.328V283.409C407.247 284.037 407.016 284.643 406.598 285.109L399.019 293.57C398.542 294.103 397.862 294.407 397.15 294.407ZM392.089 282.432L397.15 288.081L402.211 282.432V279.158L399.338 275.204C398.649 274.256 398.696 272.956 399.451 272.061L402.211 268.788V265.515L399.485 261.775C398.838 260.889 398.832 259.683 399.47 258.79L402.211 254.953V249.801C402.211 248.765 402.836 247.832 403.789 247.446C410.572 244.697 414.955 238.159 414.955 230.792C414.955 220.897 406.968 212.848 397.15 212.848C387.332 212.848 379.345 220.897 379.345 230.792C379.345 238.159 383.728 244.697 390.51 247.446C391.464 247.833 392.089 248.765 392.089 249.801V282.432Z",
    fill: "#83BAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.15 233.154C392.984 233.154 389.595 229.738 389.595 225.539C389.595 221.341 392.984 217.925 397.15 217.925C401.316 217.925 404.706 221.341 404.706 225.539C404.706 229.738 401.316 233.154 397.15 233.154ZM397.15 223.001C395.761 223.001 394.632 224.14 394.632 225.539C394.632 226.939 395.761 228.077 397.15 228.077C398.539 228.077 399.669 226.939 399.669 225.539C399.669 224.14 398.539 223.001 397.15 223.001Z",
    fill: "#83BAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_554_13413",
    x: 119,
    y: 116,
    width: 385,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_554_13413"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_554_13413"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_554_13413"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_554_13413",
    result: "effect2_dropShadow_554_13413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_554_13413",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_554_13413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 339,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProperty);
export default __webpack_public_path__ + "static/media/HomeProperty.67c08079c147a16e9650df3f50be77c9.svg";
export { ForwardRef as ReactComponent };